<template>
  <div class="feature-root">
    <p class="title">{{title}}</p>
    <div class="text-btn" v-for="(item, index) in featureList" :key="index">
      <a v-for="f in item" :key="f" :style="{flex: item.length == 1 ? '0.5' : '1'}">{{f}}</a>
    </div>
    <div id="link-us">
      <a>联系获得授权</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    features: Array // [[1, 2], [3, 4]]
  },
  data() {
    return {
      featureList: []
    }
  },
  mounted() {
    if (this.features && this.features.length > 0) {
      let arr = []
      for (let index = 0; index < this.features.length; index++) {
        const element = this.features[index]
        arr.push(element)
        if (arr.length === 2 || index === this.features.length - 1) {
          this.featureList.push(arr)
          arr = []
        }
      }
      window.console.log(this.featureList)
      // alert(JSON.stringify(this.featureList))
    }
  }
}
</script>

<style lang="less" scoped>
.feature-root {
  border-top: 1px solid #a0d36e;
  width: 285px;
  background-color: #eee;
  margin: 18px auto 0;
  .title {
    font-size: 16px;
    padding: 11px;
    margin: 0;
    border-bottom: 1px solid #ccc;
  }
  .text-btn {
    display: flex;
    margin: 11px 0;
    a {
      margin: 0 5px;
      flex: 1;
      display: block;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        background-color: #a0d36e;
        color: white;
      }
    }
  }
  #link-us {
    padding-bottom: 26px;
    margin-top: 40px;
    a {
      cursor: pointer;
      padding: 8px 11px;
      display: inline-block;
      border: 1px solid #a0d36e;
      font-size: 14px;
      color: #a0d36e;
      background-color: white;
      &:hover {
        background-color: #a0d36e;
        color: white;
      }
    }
  }
}
</style>

